import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../environments/environment";
import { Alert, AlertsSummary } from "../interfaces/alert.interface";
import {
  PaginatedResponse,
  Pagination,
} from "../interfaces/pagination.interface";

@Injectable({
  providedIn: "root",
})
export class AlertService {
  constructor(private http: HttpClient) {}

  getAlertsSummary(): Observable<AlertsSummary> {
    return this.http.get<AlertsSummary>(`${environment.API_URL}alerts/summary`);
  }

  getGlobalAlerts(
    pagination: Pagination,
  ): Observable<PaginatedResponse<Alert>> {
    return this.http
      .get<PaginatedResponse<Alert>>(`${environment.API_URL}alerts`, {
        params: { ...pagination },
      })
      .pipe
      // TODO DELETE. HERE FOR TESTING PURPOSES ONLY
      // tap((r) =>
      //   r.content.forEach((c) => {
      //     if (Math.random() < 0.5) {
      //       c.alertStatus = AlertStatus.ACTIVE;
      //     }
      //   }),
      // ),
      ();
  }

  getGlobalActiveAlerts(
    pagination: Pagination,
  ): Observable<PaginatedResponse<Alert>> {
    return this.http.get<PaginatedResponse<Alert>>(
      `${environment.API_URL}alerts/active`,
      { params: { ...pagination } },
    );
  }

  getProjectAlerts(projectId: string): Observable<Alert[]> {
    return this.http.get<Alert[]>(
      `${environment.API_URL}projects/${projectId}/alerts/active`,
    );
  }

  dismissAlert(alertId: string): Observable<void> {
    return this.http.patch<void>(
      `${environment.API_URL}alerts/${alertId}/dismiss`,
      {},
    );
  }
}
